import { render } from "./home-featured.vue?vue&type=template&id=50ba7894"
import script from "./home-featured.vue?vue&type=script&lang=js"
export * from "./home-featured.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__